/**
 * OAuth utility functions for CSRF protection and state management
 */

/**
 * Generate a cryptographically secure random state parameter for OAuth CSRF protection
 */
export function generateOAuthState(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Store OAuth state in sessionStorage for CSRF verification
 * @param provider OAuth provider name
 * @param state Generated state value
 */
export function storeOAuthState(provider: string, state: string): void {
  sessionStorage.setItem(`oauth_state_${provider}`, state);
}

/**
 * Verify OAuth state matches stored value and clear it
 * @param provider OAuth provider name
 * @param receivedState State value received from OAuth callback
 * @returns true if state is valid, false otherwise
 */
export function verifyOAuthState(provider: string, receivedState: string): boolean {
  const storedState = sessionStorage.getItem(`oauth_state_${provider}`);
  sessionStorage.removeItem(`oauth_state_${provider}`);

  // Both must exist and match
  return !!storedState && !!receivedState && storedState === receivedState;
}
